/**
 * Job detail chart styling — uses CSS variables from `styles/jc-public-theme.css`
 * so SVG fills/strokes follow light/dark without hooks.
 */

export const jobChartVar = {
  accent: 'var(--jc-accent)',
  accentSoft: 'var(--jc-accent-soft)',
  accentMuted: 'var(--jc-accent-muted)',
  cta: 'var(--jc-cta)',
  surface: 'var(--jc-surface)',
  border: 'var(--jc-border)',
  elevated: 'var(--jc-elevated)',
  page: 'var(--jc-page)',
  gold: 'var(--jc-gold)',
  goldLine: 'var(--jc-gold-line)',
  goldBg: 'var(--jc-gold-bg)',
  ink: 'var(--jc-ink)',
  inkSecondary: 'var(--jc-ink-secondary)',
  muted: 'var(--jc-muted)',
  filterLocationBorder: 'var(--jc-filter-location-border)',
  filterCompanyBorder: 'var(--jc-filter-company-border)',
  filterSalaryText: 'var(--jc-filter-salary-text)',
  filterJobBg: 'var(--jc-filter-job-bg)',
  filterJobText: 'var(--jc-filter-job-text)',
} as const;

/** Distinct series hues for multi-segment charts (donut, starburst, company bars). */
export const jobChartSeriesVars: readonly string[] = [
  jobChartVar.cta,
  jobChartVar.accentSoft,
  jobChartVar.goldLine,
  jobChartVar.filterCompanyBorder,
  jobChartVar.filterLocationBorder,
  jobChartVar.filterSalaryText,
  jobChartVar.filterJobText,
  jobChartVar.accent,
];

/** Salary distribution row colours (most → least specific ordering in UI). */
export const salaryDistributionColors = {
  title: jobChartVar.cta,
  titleRoleLevel: jobChartVar.filterSalaryText,
  /** All roles / listings aggregated for a location (LOCATION-only bucket). */
  locationMarket: jobChartVar.goldLine,
  companyLocation: jobChartVar.filterCompanyBorder,
  titleLocation: jobChartVar.filterLocationBorder,
  job: jobChartVar.accentSoft,
} as const;
